export const NUM_ITEMS_PER_PAGE = 10;
export const SORT_MODES = {
  SORT_DATE_ASCEND: 1,
  SORT_DATE_DESCEND: 2,
  SORT_EVALUATION_ASCEND: 3,
  SORT_EVALUATION_DESCEND: 4
};
export const EVALUATION_DESCENDING_ORDER = [
  '良い', '', '悪い'
];